import { Flex } from "@chakra-ui/react";
import TableList from "components/TableList";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "services/api";
import { toaster } from "components/ui/toaster";
import { Header } from "components/Header";
import InputComp from "components/InputComp";
import ButtonComp from "components/Button";
import PaginationComp from "components/PaginationComp";

const headers = ["Company Name", "First Name", "Last Name", "Town"];

// const items = [
//   {
//     id: 1,
//     dealer: "106 car shop",
//     town: "Bolton",
//   },
//   {
//     id: 1,
//     dealer: "106 car shop 2",
//     town: "Bolton 3",
//   },
// ];

function ManageUsers() {
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  // const [selectedItem, setSelectedItem] = useState();
  const [activePage, setActivePage] = useState(1);
  const [searchTxt, setSearchTxt] = useState("");
  // const [searchLoading, setSearchLoading] = useState(false);

  const navigate = useNavigate();

  const onOpen = (data) => {
    navigate("/useradd", {
      state: {
        action: "useradd-edit",
        data: data?.item?.data,
      },
    });
  };

  const onNew = () => {
    navigate("/useradd", {
      state: {
        action: "useradd-add",
        data: {},
      },
    });
  };

  const getList = async (data) => {
    setIsLoading(true);

    // let stext = data?.searchtxt || "";
    // if (data?.searchtxt) {
    //   setSearchTxt(data?.searchtxt);
    //   data.page = 1;
    // }

    return api
      .getUsers({
        searchtxt: data?.searchtxt,
        page: data?.page || 1,
      })
      .then((res) => {
        setIsLoading(false);
        if (res?.status === 200) {
          console.log("getList", res.data);
          if (data?.page) {
            setActivePage(data.page);
          }

          if (res?.data && res?.data[0]?.userid) {
            const l = res.data.map((item) => ({
              id: item?.userid,

              companyname: `${item?.companyname || ""}`,
              firstname: `${item?.firstname || ""}`,
              lastname: `${item?.lastname || ""}`,
              town: item?.town || "",
              data: item,
            }));
            setList(l);
          } else {
            setList([]);
          }
        } else {
          setList([]);
          toaster.create({
            title: res?.message,
            type: "error",
          });
        }
      });
  };

  const onChangeSearchTxt = (v) => {
    setSearchTxt(v);
    getList({ searchtxt: v, page: 1 });
    // setSearchLoading(true);
  };

  const onSelectItm = (data) => {
    onOpen(data);
    // console.log("selected item d id =", data?.item?.data?.durationtype);
    // setSelectedItem(data);

    // setDurationvalue(data?.item?.data?.durationvalue);

    // let list2 = JSON.parse(JSON.stringify(durationTypeDD));
    // let index;
    // let item;
    // if (list2 && list2[0]) {
    //   list2 = list2.map((a, idx) => {
    //     if (a?.data?.durationtype === data?.item?.data?.durationtype) {
    //       a.selected = true;
    //       item = a;
    //       index = idx;
    //     } else {
    //       a.selected = false;
    //     }
    //     return a;
    //   });
    // }

    // onChangeDurationDD({
    //   index,
    //   item,
    //   list: list2,
    // });
  };

  const onChangePage = (data) => {
    if (data?.page === activePage) {
      return;
    }
    getList({
      page: data.page,
      // limitId: utils.getLimitId(filerLast),
      searchTxt: searchTxt,
      // dealerid: utils.getDealerid(dealers),
    });
  };

  useEffect(() => {
    const cd = async () => {
      await getList();
    };
    cd();
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header label={"Users"} isLoading={isLoading} />
      <Flex wrap={"wrap"} justify="end" gap={"1rem"} mb={"1rem"}>
        {/* <SearchInput
          // placeholder="Search"
          onChange={onChangeSearchTxt}
          loading={searchLoading}
        /> */}

        {/* <Button variant="outline" onClick={onNew}>
          Open
          </Button>
          <Button variant="outline" onClick={onNew}>
          Delete
          </Button> */}
        <ButtonComp label="New" keyname="new" onClick={onNew} />
        <InputComp
          type={"search"}
          onChange={onChangeSearchTxt}
          value={searchTxt}
          keyname={"search"}
        />
      </Flex>
      <TableList
        type="simple"
        headers={headers}
        items={list}
        onSelect={onSelectItm}
        // selectedItem={selectedItem}
      />
      <PaginationComp
        // pageSize={10}
        itemsLength={list?.length}
        activePage={activePage}
        onChange={onChangePage}
      />
    </Flex>
  );
}

export default ManageUsers;
